// ============================================================
// INSTAGRAM DRAFT MODELS
// HR3
// ============================================================


// ============================================================
// HELPERS
// ============================================================

function asObject(value) {
    return value && typeof value === "object" && !Array.isArray(value)
      ? value
      : {};
  }
  
  function asArray(value) {
    return Array.isArray(value) ? value : [];
  }
  
  function asString(value, fallback = "") {
    return value === null || value === undefined
      ? fallback
      : String(value);
  }
  
  function asNumber(value, fallback = 0) {
    if (value === null || value === undefined || value === "") {
      return fallback;
    }
  
    const number = Number(value);
  
    return Number.isFinite(number) ? number : fallback;
  }
  
  
  // ============================================================
  // INSTAGRAM DRAFT IMAGE
  // ============================================================
  
  export class InstagramDraftImage {
  
    constructor(data = {}) {
      const source = asObject(data);
  
      this.storagePath = asString(
        source.storage_path ?? source.storagePath
      );
  
      this.storageUri = asString(
        source.storage_uri ?? source.storageUri
      );
  
      this.filename = asString(
        source.filename
      );
  
      this.contentType = asString(
        source.content_type ?? source.contentType,
        "image/jpeg"
      );
  
      this.width = asNumber(
        source.width
      );
  
      this.height = asNumber(
        source.height
      );
  
      this.sizeBytes = asNumber(
        source.size_bytes ?? source.sizeBytes
      );
  
      this.previewUrl = asString(
        source.preview_url ?? source.previewUrl
      );
    }
  
    // ==========================================================
    // COMPUTED PROPERTIES
    // ==========================================================
  
    get hasPreview() {
      return Boolean(this.previewUrl);
    }
  
    get hasStorageFile() {
      return Boolean(
        this.storagePath || this.storageUri
      );
    }
  
    get aspectRatio() {
      if (!this.width || !this.height) {
        return 1080 / 1350;
      }
  
      return this.width / this.height;
    }
  
    get sizeMB() {
      return this.sizeBytes / (1024 * 1024);
    }
  
    // ==========================================================
    // SERIALIZATION
    // ==========================================================
  
    toJSON() {
      return {
        storage_path: this.storagePath,
        storage_uri: this.storageUri,
        filename: this.filename,
        content_type: this.contentType,
        width: this.width,
        height: this.height,
        size_bytes: this.sizeBytes,
      };
    }
  }
  
  
  // ============================================================
  // INSTAGRAM DRAFT COVER
  // ============================================================
  
  export class InstagramDraftCover {
  
    constructor(data = {}) {
      const source = asObject(data);
  
      this.type = "cover";
  
      this.position = asNumber(
        source.position,
        1
      );
  
      this.templateNumber = asNumber(
        source.template_number ?? source.templateNumber
      );
  
      this.image = source.image
        ? new InstagramDraftImage(source.image)
        : null;
    }
  
    // ==========================================================
    // COMPUTED PROPERTIES
    // ==========================================================
  
    get previewUrl() {
      return this.image?.previewUrl || "";
    }
  
    get hasImage() {
      return Boolean(
        this.image?.hasStorageFile ||
        this.image?.hasPreview
      );
    }
  
    get templateName() {
      return this.templateNumber
        ? `Шаблон №${this.templateNumber}`
        : "Шаблон не указан";
    }
  
    // ==========================================================
    // SERIALIZATION
    // ==========================================================
  
    toJSON() {
      return {
        type: "cover",
        position: this.position,
        template_number: this.templateNumber,
        image: this.image?.toJSON() || null,
      };
    }
  }
  
  
  // ============================================================
  // INSTAGRAM DRAFT VACANCY
  // ============================================================
  
  export class InstagramDraftVacancy {
  
    constructor(data = {}) {
      const source = asObject(data);
  
      // ========================================================
      // IDENTIFICATION
      // ========================================================
  
      this.vacancyId = asString(
        source.vacancy_id ?? source.vacancyId
      );
  
      this.position = asNumber(
        source.position
      );
  
      // ========================================================
      // VACANCY
      // ========================================================
  
      this.title = asString(
        source.title
      );
  
      this.companyName = asString(
        source.company_name ?? source.companyName
      );
  
      this.salaryText = asString(
        source.salary_text ?? source.salaryText
      );
  
      this.locationText = asString(
        source.location_text ?? source.locationText
      );
  
      this.description = asString(
        source.description
      );
  
      this.companyAbout = asString(
        source.company_about ?? source.companyAbout
      );
  
      // ========================================================
      // DETAILS
      // ========================================================
  
      this.isRemote = Boolean(
        source.is_remote ?? source.isRemote
      );
  
      this.createdTimestamp = (
        source.created_timestamp ??
        source.createdTimestamp ??
        null
      );
  
      this.vacancyUrl = asString(
        source.vacancy_url ?? source.vacancyUrl
      );
  
      // ========================================================
      // SOURCE IMAGES
      // ========================================================
  
      this.imageUrl = asString(
        source.image_url ?? source.imageUrl
      );
  
      this.companyLogoUrl = asString(
        source.company_logo_url ?? source.companyLogoUrl
      );
  
      // ========================================================
      // GENERATED IMAGE
      // ========================================================
  
      this.image = source.image
        ? new InstagramDraftImage(source.image)
        : null;
    }
  
    // ==========================================================
    // COMPUTED PROPERTIES
    // ==========================================================
  
    get previewUrl() {
      return this.image?.previewUrl || "";
    }
  
    get hasImage() {
      return Boolean(
        this.image?.hasStorageFile ||
        this.image?.hasPreview
      );
    }
  
    get displayCompanyName() {
      return this.companyName || "Компания не указана";
    }
  
    get displayTitle() {
      return this.title || "Вакансия без названия";
    }
  
    get hasCompanyAbout() {
      return Boolean(
        this.companyAbout.trim()
      );
    }
  
    // ==========================================================
    // SERIALIZATION
    // ==========================================================
  
    toJSON() {
      return {
        vacancy_id: this.vacancyId,
        position: this.position,
  
        title: this.title,
        company_name: this.companyName,
  
        salary_text: this.salaryText,
        location_text: this.locationText,
  
        description: this.description,
        company_about: this.companyAbout,
  
        is_remote: this.isRemote,
        created_timestamp: this.createdTimestamp,
  
        vacancy_url: this.vacancyUrl,
  
        image_url: this.imageUrl,
        company_logo_url: this.companyLogoUrl,
  
        image: this.image?.toJSON() || null,
      };
    }
  }
  
  
  // ============================================================
  // INSTAGRAM DRAFT CAROUSEL SLIDE
  // ============================================================
  
  export class InstagramDraftSlide {
  
    constructor(data = {}) {
      const source = asObject(data);
  
      this.type = asString(
        source.type,
        "vacancy"
      );
  
      this.position = asNumber(
        source.position
      );
  
      this.vacancyId = asString(
        source.vacancy_id ?? source.vacancyId
      );
  
      this.title = asString(
        source.title
      );
  
      this.templateNumber = asNumber(
        source.template_number ?? source.templateNumber
      );
  
      this.image = source.image
        ? new InstagramDraftImage(source.image)
        : null;
    }
  
    // ==========================================================
    // COMPUTED PROPERTIES
    // ==========================================================
  
    get isCover() {
      return this.type === "cover";
    }
  
    get isVacancy() {
      return this.type === "vacancy";
    }
  
    get previewUrl() {
      return this.image?.previewUrl || "";
    }
  
    get displayTitle() {
      if (this.isCover) {
        return "Обложка дайджеста";
      }
  
      return this.title || "Вакансия";
    }
  
    // ==========================================================
    // SERIALIZATION
    // ==========================================================
  
    toJSON() {
      return {
        type: this.type,
        position: this.position,
        vacancy_id: this.vacancyId || null,
        title: this.title || null,
        template_number: this.isCover
          ? this.templateNumber
          : null,
        image: this.image?.toJSON() || null,
      };
    }
  }
  
  
  // ============================================================
  // INSTAGRAM DRAFT
  // ============================================================
  
  export default class InstagramDraft {
  
    // ==========================================================
    // CONSTRUCTOR
    // ==========================================================
  
    constructor(data = {}) {
      const source = asObject(data);
  
      // ========================================================
      // IDENTIFICATION
      // ========================================================
  
      this.id = asString(
        source.id ?? source.digest_date ?? source.digestDate
      );
  
      this.digestDate = asString(
        source.digest_date ?? source.digestDate ?? source.id
      );
  
      // ========================================================
      // STATUS
      // ========================================================
  
      this.status = asString(
        source.status,
        "pending_review"
      );
  
      this.publicationStatus = asString(
        source.publication_status ?? source.publicationStatus,
        "not_published"
      );
  
      // ========================================================
      // INSTAGRAM CAPTION
      // ========================================================
  
      this.caption = asString(
        source.caption
      );
  
      // ========================================================
      // COVER
      // ========================================================
  
      this.cover = source.cover
        ? new InstagramDraftCover(source.cover)
        : null;
  
      // ========================================================
      // VACANCIES
      // ========================================================
  
      this.items = asArray(
        source.items
      ).map(
        item => new InstagramDraftVacancy(item)
      );
  
      // ========================================================
      // CAROUSEL
      // ========================================================
  
      this.carousel = asArray(
        source.carousel
      ).map(
        slide => new InstagramDraftSlide(slide)
      );
  
      // Старые дайджесты могут не содержать carousel.
      if (!this.carousel.length) {
        this.carousel = this._buildFallbackCarousel();
      }
  
      this._sortCarousel();
  
      // ========================================================
      // COUNTERS
      // ========================================================
  
      this.vacancyCount = asNumber(
        source.vacancy_count ?? source.vacancyCount,
        this.items.length
      );
  
      this.carouselCount = this.carousel.length;
  
      // ========================================================
      // DATES
      // ========================================================
  
      this.createdAt = (
        source.created_at ??
        source.createdAt ??
        null
      );
  
      this.updatedAt = (
        source.updated_at ??
        source.updatedAt ??
        null
      );
    }
  
    // ==========================================================
    // CREATE FROM API
    // ==========================================================
  
    static fromApi(data) {
      return new InstagramDraft(data);
    }
  
    // ==========================================================
    // CREATE ARRAY FROM API
    // ==========================================================
  
    static fromApiArray(data) {
      return asArray(data).map(
        item => new InstagramDraft(item)
      );
    }
  
    // ==========================================================
    // FALLBACK CAROUSEL
    // ==========================================================
  
    _buildFallbackCarousel() {
      const slides = [];
  
      // --------------------------------------------------------
      // COVER FIRST
      // --------------------------------------------------------
  
      if (this.cover?.hasImage) {
        slides.push(
          new InstagramDraftSlide({
            type: "cover",
            position: 1,
            template_number: this.cover.templateNumber,
            image: this.cover.image?.toJSON(),
          })
        );
      }
  
      // --------------------------------------------------------
      // VACANCIES
      // --------------------------------------------------------
  
      const sortedItems = [...this.items].sort(
        (a, b) => a.position - b.position
      );
  
      sortedItems.forEach((item, index) => {
        slides.push(
          new InstagramDraftSlide({
            type: "vacancy",
            position: slides.length + 1,
            vacancy_id: item.vacancyId,
            title: item.title,
            image: item.image?.toJSON(),
          })
        );
      });
  
      return slides;
    }
  
    // ==========================================================
    // SORT CAROUSEL
    // ==========================================================
  
    _sortCarousel() {
      this.carousel.sort(
        (a, b) => a.position - b.position
      );
    }
  
    // ==========================================================
    // COMPUTED — COVER
    // ==========================================================
  
    get hasCover() {
      return Boolean(this.cover?.hasImage);
    }
  
    get coverPreviewUrl() {
      return this.cover?.previewUrl || "";
    }
  
    get coverTemplateNumber() {
      return this.cover?.templateNumber || null;
    }
  
    // ==========================================================
    // COMPUTED — STATUS
    // ==========================================================
  
    get isPendingReview() {
      return this.status === "pending_review";
    }
  
    get isProcessing() {
      return this.status === "processing";
    }
  
    get isPublished() {
      return (
        this.status === "published" ||
        this.publicationStatus === "published"
      );
    }
  
    get canEdit() {
      return (
        this.isPendingReview &&
        this.publicationStatus === "not_published"
      );
    }
  
    get statusText() {
      const statuses = {
        pending_review: "Ожидает проверки",
        processing: "Обрабатывается",
        approved: "Одобрен",
        published: "Опубликован",
        rejected: "Отклонён",
        failed: "Ошибка",
      };
  
      return statuses[this.status] || this.status;
    }
  
    // ==========================================================
    // COMPUTED — DATE
    // ==========================================================
  
    get displayDate() {
      if (!this.digestDate) {
        return "Дата не указана";
      }
  
      const parts = this.digestDate.split("-");
  
      if (parts.length !== 3) {
        return this.digestDate;
      }
  
      const [year, month, day] = parts;
  
      const months = [
        "января",
        "февраля",
        "марта",
        "апреля",
        "мая",
        "июня",
        "июля",
        "августа",
        "сентября",
        "октября",
        "ноября",
        "декабря",
      ];
  
      const monthIndex = Number(month) - 1;
  
      if (
        monthIndex < 0 ||
        monthIndex >= months.length
      ) {
        return this.digestDate;
      }
  
      return `${Number(day)} ${months[monthIndex]} ${year}`;
    }
  
    get title() {
      return `Дайджест вакансий за ${this.displayDate}`;
    }
  
    // ==========================================================
    // COMPUTED — ITEMS
    // ==========================================================
  
    get hasVacancies() {
      return this.items.length > 0;
    }
  
    get actualVacancyCount() {
      return this.items.length;
    }
  
    get actualCarouselCount() {
      return this.carousel.length;
    }
  
    // ==========================================================
    // COMPUTED — CAROUSEL
    // ==========================================================
  
    get slides() {
      return [...this.carousel].sort(
        (a, b) => a.position - b.position
      );
    }
  
    get firstSlide() {
      return this.slides[0] || null;
    }
  
    get previewUrl() {
      return (
        this.coverPreviewUrl ||
        this.firstSlide?.previewUrl ||
        this.items[0]?.previewUrl ||
        ""
      );
    }
  
    // ==========================================================
    // FIND VACANCY
    // ==========================================================
  
    getVacancyById(vacancyId) {
      return this.items.find(
        item => item.vacancyId === String(vacancyId)
      ) || null;
    }
  
    // ==========================================================
    // UPDATE CAPTION (LOCAL STATE)
    // ==========================================================
  
    updateCaption(value) {
      this.caption = asString(value);
    }
  
    // ==========================================================
    // REORDER CAROUSEL (LOCAL STATE)
    // ==========================================================
  
    moveSlide(fromIndex, toIndex) {
      if (!this.canEdit) {
        return false;
      }
  
      const slides = [...this.slides];
  
      if (
        !Number.isInteger(fromIndex) ||
        !Number.isInteger(toIndex) ||
        fromIndex < 0 ||
        toIndex < 0 ||
        fromIndex >= slides.length ||
        toIndex >= slides.length
      ) {
        return false;
      }
  
      // Обложка всегда остаётся первым слайдом.
      if (slides[0]?.isCover) {
        if (fromIndex === 0 || toIndex === 0) {
          return false;
        }
      }
  
      const [slide] = slides.splice(
        fromIndex,
        1
      );
  
      slides.splice(
        toIndex,
        0,
        slide
      );
  
      slides.forEach((item, index) => {
        item.position = index + 1;
      });
  
      this.carousel = slides;
  
      this.carouselCount = slides.length;
  
      return true;
    }
  
    // ==========================================================
    // SERIALIZATION
    // ==========================================================
  
    toJSON() {
      return {
        id: this.id,
        digest_date: this.digestDate,
  
        status: this.status,
        publication_status: this.publicationStatus,
  
        caption: this.caption,
  
        cover: this.cover?.toJSON() || null,
  
        items: this.items.map(
          item => item.toJSON()
        ),
  
        carousel: this.slides.map(
          slide => slide.toJSON()
        ),
  
        vacancy_count: this.vacancyCount,
        carousel_count: this.carousel.length,
  
        created_at: this.createdAt,
        updated_at: this.updatedAt,
      };
    }
  }